import React from "react";
import { Flex, Image, Text } from "@chakra-ui/react";

// Base Image Component
const BaseImage = ({
  src,
  alt,
  title,
  maxHeight,
}: {
  src: string;
  alt: string;
  title?: string;
  maxHeight?: string[];
}) => {
  return (
    <Flex
      width="100%"
      textAlign="center" 
      justifyContent={'center'}
     alignItems={'center'}
     flexDirection={'column'}
    >
      {/* Image */}
      <Image
        src={src}
        alt={alt}
        maxH={maxHeight ? maxHeight : ["none"]}
        objectFit="contain"
        loading="lazy"
      />
      {/* Optional Title */}
      {title && (
        <Text          
          fontSize="xl"
          textDecoration="underline"
          mt={2}
        >
          {title}
        </Text>
      )}
    </Flex>
  );
};

// Landscape Image Component
export const LandscapeImage = ({
  src,
  alt,
  title,
}: {
  src: string;
  alt: string;
  title?: string;
}) => {
  return <BaseImage src={src} alt={alt} title={title} />;
};

// Portrait Image Component
export const PortraitImage = ({
  src,
  alt,
  title,
  maxHeight,
}: {
  src: string;
  alt: string;
  title?: string;
  maxHeight?: string[];
}) => {
  return <BaseImage src={src} alt={alt} title={title} maxHeight={maxHeight} />;
};

// Xpan Image Component
export const XpanImage = ({
  src,
  alt,
  title,
}: {
  src: string;
  alt: string;
  title?: string;
}) => {
  return <BaseImage src={src} alt={alt} title={title} />;
};
